import { render } from "./AppAlertDialog.vue?vue&type=template&id=a6423766"
import script from "./AppAlertDialog.vue?vue&type=script&lang=js"
export * from "./AppAlertDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__